import * as BusinessManagerAPI from '@wix/business-manager-api';
import { NavigationState, NavigationProps } from './navigation-store';
import { PageRoute } from '@src/types';

interface NavigationActionsProps extends NavigationProps {
  pendingChanges: boolean;
  mounted: boolean;
  cancelPendingChanges(): void;
}

interface ActionProps {
  getState(): NavigationState;
  setState(state: Partial<NavigationState>): void;
  getProps(): NavigationActionsProps;
}

const BMPendingNavigation = 'BM_PENDING_NAV';
const StateRoutes = [PageRoute.BANNER_SETTINGS, PageRoute.ADVANCED_OPTIONS];

let _resume: (() => void) | null = null;

export const listenToBMNavigation = ({ setState, getProps }: ActionProps) => {
  BusinessManagerAPI.onNavigation((pause) => {
    const { pendingChanges, mounted } = getProps();
    if (!mounted) {
      return;
    }

    if (pendingChanges) {
      const { resume } = pause();
      _resume = resume;
      setState({ pendingRoute: BMPendingNavigation });
    }
  });
};

export const cancelNavigation = ({ setState, getProps }: ActionProps) => () => {
  if (getProps().mounted) {
    setState({ pendingRoute: false });
    _resume = null;
  }
};

export const navigateToRoute = ({ setState, getProps }: ActionProps) => (route: PageRoute) => {
  const { history, pendingChanges } = getProps();

  if (pendingChanges && !StateRoutes.includes(route)) {
    setState({ pendingRoute: route });
  } else {
    history.push(route);
  }
};

export const resumeNavigation = ({ setState, getState, getProps }: ActionProps) => () => {
  const { pendingRoute } = getState();
  const { mounted, history, cancelPendingChanges } = getProps();
  if (mounted && pendingRoute !== false) {
    if (pendingRoute !== BMPendingNavigation) {
      history.push(pendingRoute);
    } else {
      _resume && _resume();
    }
    setState({ pendingRoute: false });
    cancelPendingChanges();
  }
};

export interface INavigationActions {
  resumeNavigation(): void;
  cancelNavigation(): void;
  navigateToRoute(route: PageRoute): void;
}

export const getNavigationActions = (actionProps: ActionProps): INavigationActions => {
  listenToBMNavigation(actionProps);

  return {
    cancelNavigation: cancelNavigation(actionProps),
    navigateToRoute: navigateToRoute(actionProps),
    resumeNavigation: resumeNavigation(actionProps),
  };
};
